import { convertIrskomUserToUser } from "./converters";
import { IrskomUser } from "./types";
import { BaseUsersClient, User, UserWithPassword, RemoveUserResponse } from "@core/types";

class UsersClient extends BaseUsersClient {
  async getProfile(): Promise<User> {
    const res = await this.instance.get<IrskomUser>("account/details");

    return convertIrskomUserToUser(res.data);
  }

  async updateProfile(userId: string, updateData: Partial<UserWithPassword>): Promise<Partial<User>> {
    const userSendData: IrskomUser = {
      birthDay: "01.01.1990",
      discountCardImage: "",
      discountCardNumber: "",
      firstName: updateData.firstName ?? "",
      id: userId,
      lastName: updateData.lastName ?? "",
      phoneNumber: updateData.phone!,
      sex: 0,
    };

    await this.instance.post("account/update", {
      ...userSendData,
    });

    return updateData;
  }

  async deleteMe(): Promise<RemoveUserResponse> {
    throw new Error("deleteMe not implemented");
  }
}

export default UsersClient;
